import { MessageSquare, Search, Zap, ArrowUp } from "lucide-react";

const features = [
  { icon: MessageSquare, text: "Chat with your community concierge" },
  { icon: Search, text: "Find events, resources, and connections" },
  { icon: Zap, text: "Instant responses, always available" },
];

const ChatSection = () => {
  return (
    <section className="py-24 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Chat demo */}
          <div className="order-2 md:order-1">
            <ChatDemo />
          </div>

          <div className="order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-6">
              Just ask—I'm here to help
            </h2>
            
            <p className="text-muted-foreground text-lg mb-8">
              Need to find an event, connect with a member, or navigate community resources? 
              Simply ask in natural language. It's like having a dedicated team member at your fingertips.
            </p>

            <div className="space-y-4">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={feature.text}
                    className="flex items-center gap-3 opacity-0 animate-fade-in"
                    style={{ animationDelay: `${index * 0.15}s` }}
                  >
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon className="w-4 h-4 text-primary" />
                    </div>
                    <span className="text-foreground">{feature.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ChatDemo = () => {
  const messages = [
    { role: "user", content: "Are there any networking events this week?" },
    { role: "assistant", content: "Yes! There's a coffee chat on Thursday at the Cafe at 3 PM and an in-person mixer on Friday at 4 PM. Would you like more detail about either one?" },
  ];

  return (
    <div className="landing-glass rounded-2xl p-6 landing-glow-primary">
      <div className="space-y-4 mb-4">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}
          >
            <div
              className={`max-w-[80%] rounded-lg p-3 ${
                msg.role === "user"
                  ? "bg-primary text-primary-foreground"
                  : "bg-secondary text-secondary-foreground"
              }`}
            >
              <p className="text-sm">{msg.content}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 landing-glass rounded-full p-2 px-4">
        <input
          type="text"
          placeholder="Just ask, Concierge is here to help."
          readOnly
          className="flex-1 bg-transparent text-foreground placeholder:text-muted-foreground outline-none text-sm px-2 cursor-default"
        />
        <button className="bg-primary rounded-full p-2 transition-colors">
          <ArrowUp className="w-4 h-4 text-primary-foreground" />
        </button>
      </div>
    </div>
  );
};

export default ChatSection;
